module.exports = __webpack_public_path__ + "media/images/site/premier-0faab5d3f2423c2046cccc92a7191009.png";